// extracted by mini-css-extract-plugin
export default {"title":"KnowledgeBaseItem_title__tCz0E"};